/**
 * Created by fuzhengsong on 2017/9/7.
 */

import Vue from 'vue';
import './placeholder';
import vueSticky from './sticky';

Vue.use(vueSticky);


// WEBPACK FOOTER //
// ./src/directive/index.js